import React from "react";
import { Link } from "react-router-dom";

function Footer(props) {
  return (
    <footer className="footer-container">
      <section>
        <div className="flex-2">
          <div className="place-left">
            <nav>
              <ul className="grid-3">
                <li>
                  <Link>menu</Link>
                  <ul>
                    <li>
                      <Link to="/">home</Link>
                    </li>
                    <li>
                      <Link to="/aboutus">about us</Link>
                    </li>
                    <li>
                      <Link to="/services">services</Link>
                    </li>
                    <li>
                      <Link to="/">contact us</Link>
                    </li>
                  </ul>
                </li>
                <li>
                  <Link>resources</Link>
                  <ul>
                    <li>
                      <Link to="/">blog</Link>
                    </li>
                    <li>
                      <Link to="/">pricing</Link>
                    </li>
                    <li>
                      <Link to="/">teacher</Link>
                    </li>
                    <li>
                      <Link to="/">FAQ</Link>
                    </li>
                  </ul>
                </li>
                <li>
                  <Link>location</Link>
                  <ul>
                    <li>
                      <Link>
                        No 1 Umunkanka Street Close to University Secondary
                        School, UNN.
                      </Link>
                    </li>
                  </ul>
                </li>
              </ul>
            </nav>
          </div>
          <div className="place-right">
            <h3>stay connected</h3>
            <p>
              Join our mailing list to receive information on updates on our
              site.
            </p>
            <form>
              <div className="form-field">
                <input type="email" placeholder="Enter your email"></input>
                <div className="cta-btn">
                  <button>subcribe</button>
                </div>
              </div>
            </form>
          </div>
        </div>
        <div className="end-footer flex-2">
          <div className="social-media-icons flex-4">
            {props.icons.map((icon) => (
              <div key={icon.id}>
                <Link to="/">
                  <div className="img-container">
                    <img src={icon.imgSrc} alt={icon.imgSrc} />
                  </div>
                </Link>
              </div>
            ))}
          </div>
          <small>&copy; Codeblazeacademy 2023</small>
        </div>
      </section>
    </footer>
  );
}

export default Footer;
